import React from "react";
import ReactDOM from "react-dom/client";
import "./index.scss";
import { Provider } from "react-redux";
import store from "./redux/store";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import App from "./App";
import "@fontsource/poppins";
import "@fontsource/poppins/400.css";
import "@fontsource/poppins/400-italic.css";
import "@fontsource/work-sans";
import "@fontsource/work-sans/400.css";
import "@fontsource/work-sans/400-italic.css";
import "@fontsource/inter"; // Defaults to weight 400
import "@fontsource/inter/400.css"; // Specify weight
import "@fontsource/inter/400-italic.css"; // Specify weight and style

document.addEventListener(
  "wheel",
  (event) => {
    const target = event.target;
    if (
      target instanceof HTMLInputElement &&
      target.type === "number" &&
      document.activeElement === target
    ) {
      target.blur();
    }
  },
  { passive: true }
);

const root = ReactDOM.createRoot(
  document.getElementById("dental") as HTMLElement
);

root.render(
  <React.Fragment>
    <Provider store={store}>
      <App />
    </Provider>
    <ToastContainer
      position="bottom-left"
      style={{ fontSize: "13px", maxWidth: "220px", left: "0px" }}
      toastStyle={{ minHeight: "44px" }}
    />
  </React.Fragment>
);
